import "../styles/PromptSuggestions.css";

export default function PromptSuggestions({ setSuggestion }) {
  const suggestions = [
    {
      "title": "ClearFlow Plumbing & Repair",
      "description": "A local plumbing service offering same-day repairs, emergency service, and installation for homeowners.",
      "unique": "We’re a family-owned plumbing company focused on fast, reliable service with transparent pricing. Our technicians are licensed experts who pride themselves on clean work and honest recommendations. We treat your home like our own and deliver high-quality service without surprises.",
      "pillHeading": "Local Home Services (Plumbing)"
    },
    {
      "title": "FitStride Training",
      "description": "An online store selling eco-friendly and sustainable home essentials.",
      "unique": "GreenNest Goods offers curated, environmentally responsible products made from recycled or natural materials. We focus on quality, design, and sustainability. Every product we offer is vetted to reduce waste and support a greener lifestyle.",
      "pillHeading": "Eco-Friendly Home Products"
    },
    {
      "title": "Lena Hart Design",
      "description": "A personal portfolio featuring branding, illustration, and web design projects.",
      "unique": "I’m a freelance designer specializing in vibrant visual identities and custom illustrations. My work blends bold colors with clean layouts to help brands stand out. I focus on storytelling through design, making every project personal, expressive, and memorable.",
      "pillHeading": "Creative Professional (Graphic Designer)"
    },
    {
      "title": "Everyday Spoonful",
      "description": "A food blog sharing simple, delicious recipes for busy home cooks.",
      "unique": "Everyday Spoonful focuses on approachable recipes that anyone can make with everyday ingredients. We test each dish thoroughly to make cooking easier, tastier, and more fun. Our goal is to help people spend less time stressing in the kitchen and more time enjoying great meals.",
      "pillHeading": "Food & Recipe Blog"
    },
    {
      "title": "SkillForge Academy",
      "description": "An online learning community offering video courses, tutorials, and digital downloads.",
      "unique": "SkillForge Academy brings together creators and learners in a supportive digital community. Our courses focus on practical, real-world skills taught by experienced instructors. Members get access to step-by-step lessons, resources, and ongoing mentorship that makes learning engaging and approachable.",
      "pillHeading": "Online Course Membership"
    },
    {
      "title": "FlowTrack CRM",
      "description": "A simple landing page promoting a CRM tool for small businesses.",
      "unique": "FlowTrack CRM helps small businesses organize their customer relationships with an easy, intuitive interface. Unlike complex enterprise tools, FlowTrack is designed to be fast, friendly, and affordable. We focus on helping teams follow up faster, close more deals, and reduce chaos.",
      "pillHeading": "SaaS Landing Page"
    },
    {
      "title": "TastyBite Catering",
      "description": "A full-service catering company for private events, weddings, and corporate gatherings.",
      "unique": "Offers fully customizable menus with dietary-friendly options.",
      "pillHeading": "Launch a catering services site"
    },
    {
      "title": "LearnFlow Tutoring",
      "description": "An online tutoring platform for students from elementary to college.",
      "unique": "Matches students with tutors using a personalized learning assessment.",
      "pillHeading": "Create an online tutoring website"
    },
    {
      "title": "FitStride Training",
      "description": "A personal training service focused on strength building and healthy weight management.",
      "unique": "Customized workout plans using AI-driven progress tracking.",
      "pillHeading": "Build a personal trainer site"
    }
  ];

  return (
    <section className="prompt-suggestions-section">
      <div className="prompt-suggestions-header">
        <h2 className="prompt-suggestions-heading">Start with a prompt that actually works.</h2>
        <p className="prompt-suggestions-subheading">Not sure where to get started? Pick a starter idea and we&apos;ll fill in the form for you.</p>
      </div>
      <div className="prompt-suggestions-container">
        {suggestions.map((suggestion, index) => (
          <button key={index} className="suggestion-pill" onClick={() => setSuggestion(suggestion)}>
            <span>{suggestion.pillHeading}</span>
            <img src="/sitegeneration/icons/arrow-up.svg" alt="arrow icon" className="pill-arrow-icon" />
          </button>
        ))}
      </div>
    </section>
  );
}